module.exports = __webpack_public_path__ + "media/images/missing-placeholder-1663521cf93f551627e41d3bdbb7280ae01299747c672cb1dd3d32551ff5af44.png";